import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SectionTitle from '../layout/SectionTitle';
import { Link } from 'react-router-dom';

const GenieCivil = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-8 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 md:gap-10 xl:gap-16 items-center">
          {/* Left Column - Content */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-6 order-2 md:order-1"
          >
            <div className="mb-6">
              <SectionTitle 
                overline={t('construction.civilEngineering.title')} 
                highlight=""
                align="left"
                showLogo={true}
              />
            </div>
            
            {/* Description */}
            <div className="space-y-4 text-gray-600 leading-relaxed text-justify">
              <p className="font-bold text-xl">{t('construction.civilEngineering.subtitle')}</p>  
              <p>{t('construction.civilEngineering.paragraph1')}</p>
              <p>{t('construction.civilEngineering.paragraph2')}</p>
              <p>{t('construction.civilEngineering.paragraph3')}</p>
              <p>{t('construction.civilEngineering.paragraph4')}</p>
              <p>{t('construction.civilEngineering.paragraph5')}</p>
            </div>
            
            {/* CTA Button */}
            <Link 
              to="/contact" 
              className="inline-block mt-6 bg-socabeg-red hover:bg-socabeg-red/90 text-white font-medium py-3 px-8 rounded-full transition-colors duration-300"
            >
              {t('construction.civilEngineering.cta')}
            </Link>
          </motion.div>
          
          {/* Right Column - Image */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative order-1 md:order-2"
          >
            <div className="relative z-10 rounded-lg shadow-2xl">
              <div className="rounded-lg overflow-hidden relative">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-socabeg-dark-gray/30 z-10" />
                <img 
                  src="/images/genie-civil.jpg" 
                  alt={t('construction.civilEngineering.imageAlt')}
                  className="w-full object-cover relative z-0 h-[420px] md:h-[560px] lg:h-[600px]"
                  loading="lazy"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default GenieCivil;
